import { BaseDocumentId, customNanoId } from "../base-document-id";
import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "../types";

export class PreprintDocumentId extends BaseDocumentId {
	constructor(
		id?: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super("preprint", id ?? customNanoId(), generationVersion, historyVersion);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new PreprintDocumentId(
			this.id,
			generationVersion,
			this.historyVersion,
		);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new PreprintDocumentId(
			this.id,
			this.generationVersion,
			historyVersion,
		);
	}
}
